module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0118.png.55b7e129.jpg";